function initHeaderScrollBehavior() {
  const header = document.getElementById('header-component');
  if (!header) return;

  let lastScroll = window.scrollY || 0;
  const threshold = 10;

  const updateHeaderState = () => {
    const currentScroll = window.scrollY || document.documentElement.scrollTop;

    let direction = 'none';
    let stickyState = 'inactive';

    if (currentScroll <= threshold) {
      direction = 'none';
      stickyState = 'inactive';
    } else {
      direction = currentScroll > lastScroll ? 'down' : 'up';
      stickyState = 'active';
    }    
    header.setAttribute('data-scroll-direction', direction);
    header.setAttribute('data-sticky-state', stickyState);

    lastScroll = currentScroll;
  };

  
  updateHeaderState();

 
  window.addEventListener('scroll', updateHeaderState, { passive: true });
}


document.addEventListener('DOMContentLoaded', initHeaderScrollBehavior);
        




document.addEventListener('click', (e) => {
  
  // console.log("Inside drawer---------")
  const drawer = document.querySelector('[data-collection-drawer]');
  // console.log("drawer"+ drawer);
  if (!drawer) return;

  
  const openBtn = e.target.closest('[data-open-drawer]');
  if (openBtn) {
    drawer.classList.add('is-open');
    document.body.classList.add('drawer-open');
  }


  const closeBtn = e.target.closest('[data-close-drawer]');
  if (closeBtn || e.target === drawer) {
    drawer.classList.remove('is-open');
    document.body.classList.remove('drawer-open');
  }

  const trigger = e.target.closest('[data-accordion-trigger]');
  if (!trigger) return;

  const item = trigger.closest('.drawer-item');
  const allItems = drawer.querySelectorAll('.drawer-item');

  // close others
  allItems.forEach(i => {
    if (i !== item) i.classList.remove('is-open');
  });

  // toggle current
  item.classList.toggle('is-open');
});




document.addEventListener('DOMContentLoaded', () => {
  const wrappers = document.querySelectorAll('[data-video-sequence="true"]');

  wrappers.forEach((wrapper) => {
    const slides = wrapper.querySelectorAll('[data-carousel-card]');
    let index = 0;
    let isActive = false;

    function getVideo(slide) {
      let video = slide.querySelector('video');
      if (video) return video;

      const deferred = slide.querySelector('deferred-media');
      if (deferred) {
        const button = deferred.querySelector('button');
        if (button) button.click();

        return deferred.querySelector('video');
      }
      return null;
    }

    // ✅ pause ALL videos in this wrapper
    function pauseAll(except = null) {
      const videos = wrapper.querySelectorAll('video');

      videos.forEach(v => {
        if (v !== except) {
          v.pause();
          v.currentTime = 0;
        }
      });
    }

    function goToSlide(i) {
      if (!isActive) return;

      const slideshow = wrapper.querySelector('slideshow-component');

      if (slideshow && slideshow.goToSlide) {
        slideshow.goToSlide(i);
      } else {
        slides[i]?.scrollIntoView({
          behavior: 'smooth',
          inline: 'start',
          block: 'nearest'
        });
      }
    }

    function playNext() {
      if (!isActive) return;

      if (index >= slides.length) {
        index = 0;
      }

      const slide = slides[index];
      const video = getVideo(slide);

      goToSlide(index);

      if (video) {
        video.muted = true;
        video.currentTime = 0;

        // 🔥 CRITICAL FIX: pause when it ACTUALLY starts
        video.onplay = () => {
          pauseAll(video);
        };

        video.onended = () => {
          index++;
          playNext();
        };

        video.play().catch(() => {});
      } else {
        setTimeout(() => {
          index++;
          playNext();
        }, 3000);
      }
    }

    // 🔥 GLOBAL FIX INSIDE WRAPPER (handles ALL cases)
    wrapper.addEventListener('play', (e) => {
      const video = e.target;

      if (video.tagName === 'VIDEO') {
        pauseAll(video);
      }
    }, true); // 👈 capture mode is critical

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          isActive = true;
          index = 0;
          playNext();
        } else {
          isActive = false;
          pauseAll();
        }
      });
    }, { threshold: 0.5 });

    observer.observe(wrapper);

    

  });
});



(function () {
    function injectCSS() {
        const shadowContainer = document.getElementById("upCart");
        if (!shadowContainer) {
            requestAnimationFrame(injectCSS);
            return;
        }
        const shadowRoot = shadowContainer.shadowRoot;
        if (!shadowRoot) {
            requestAnimationFrame(injectCSS);
            return;
        }
        if (shadowRoot.querySelector("#UpcartPopup")) return;
        const style = document.createElement("style");
        style.id = "UpcartPopup";
        style.textContent = `
.upcart-internal-component-upsell-tile__variant-row select {
    width: 40%;
    padding: 3px 0px;
    font-size: 11px;
}
.upcart-internal-component-product-tile__image {
    width: 88px;
    height: 88px;
    object-fit: contain;
    border-radius: 14px;
    background: #fff;
    box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
}
.upcart-internal-component-product-tile__product-title {
    font-weight: 800;
    color: #0080BF;
    font-family: 'Avenir';
    margin: 0px !important;
}
    button.upcart-internal-component__button.upcart-public-component__button {
    background: rgba(53, 74, 84, 1);
}
.upcart-internal-component-product-tile__product-pricing span.upcart-internal-component-product-tile__price {
    color: rgba(255, 72, 0, 1);
    font-family: 'Avenir';
    padding: 10px 0px 6px;
    font-weight: 600;
}
    .upcart-internal-component-product-tile {
    border-bottom: 0.7px solid rgba(255, 255, 255, 1);
}
    span.upcart-internal-cart-items__key-value-pair {
    color: rgba(129, 142, 149, 1) !important;
    font-size: 12px;
    font-family: 'Avenir';
}
.styles_CartPreview__card__ {
    background: #E6E9EA !important;
    border: 1px solid rgba(255, 255, 255, 1);
    backdrop-filter: blur(15.600000381469727px);
}
    .UpcartDesignSettings__cartAccentColor {
    background: #E6E9EA !important;
    border: 1px solid rgba(255, 255, 255, 1);
    backdrop-filter: blur(15.600000381469727px);
    border-radius: 25px 25px 0px 0px;
}
    .upcart-internal-component-upsell-tile.upcart-public-component-upsell-tile {
    border: 1px solid rgba(255, 255, 255, 1);
    background: rgba(255, 255, 255, 0.48);
}
button.upcart-internal-component-carousel__button {
    border: 1px solid rgba(255, 255, 255, 1);
    background: rgba(255, 255, 255, 0.79);
    width: 38px;
    height: 38px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 1 !important;
}
    .upcart-internal-style__title-large.upcart-internal-style__title p {
    text-align: left;
    font-size: 14px;
    letter-spacing: -2%;
    line-height: 18px;
    color: rgba(53, 74, 84, 1);
   font-family: 'Avenir';
    font-weight: 400;
}
.upcart-internal-header.upcart-public-header h3 {
    color: rgba(53, 74, 84, 1);
    font-family: 'Avenir';
    font-weight: 900;
    font-size: 24px;
    line-height: 48px;
    letter-spacing: -2%;
}
    .upcart-internal-style__title-large.upcart-internal-style__title {
    padding: 0px;
}
    .upcart-internal-header__close-button.upcart-public-header__close-button {
    border: 0.7px solid rgba(53, 74, 84, 1);
}
.upcart-internal-rewards.upcart-public-rewards {
    background: rgba(53, 74, 84, 1);
    border: 1px solid rgba(255, 255, 255, 1);
    border-radius: 16px;
    padding: 25px 20px 45px;
    height: auto;
    min-height: 130px;
    margin: 0px 30px;
}
span.only_color {
    background: #FF4800;
    padding: 3px 5px;
    border-radius: 40px;
}
.upcart-internal-rewards__message.upcart-public-rewards__message p {
    font-weight: 400;
    font-size: 13px;
    line-height: 24px;
    letter-spacing: -1%;
    text-align: center;
   font-family: 'Avenir';
    color: #fff;
    border-radius: 40px;
    width: fit-content;
    padding: 5px 20px;
    margin: auto !important;
}
    .upcart-internal-component-segmented-progress-bar__milestone-label {
    color: rgba(255, 255, 255, 0.62);
     font-family: 'Avenir';
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    letter-spacing: -1%;
    text-align: center;
    padding-top: 6px;
}
.upcart-internal-component-segmented-progress-bar__segments-container {
    width: 280px;
    margin: auto;
    height:5px;
}

.upcart-internal-component-product-tile.upcart-public-component-product-tile {
    padding: 26px 0px;
    margin: 0px 30px;
}
.shipping_title {
    display: flex;
    gap: 10px;
}
.upcart-internal-announcement {
    height: auto;
    min-height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateY(20px);
    padding-bottom: 10px;
    margin-top: -20px;
}
    .upcart-internal-upsell {
    margin: 0px 30px 14px;
}
.shipping_title span.Cart_quantity {
    background: rgba(255, 72, 0, 1);
    width: 20px;
    height: 20px;
    border-radius: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 255, 255, 1);
    font-size: 14px;
    letter-spacing: -2%;
}
    button.upcart-internal-component__button.upcart-public-component__button {
    display: block;
}
span.btn-content {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-evenly;
    font-family: 'Avenir';
    font-size: 11px;
}
    .upcart-internal-component-product-tile__remove-button {
    width: auto;
    height: auto;
}
    .upcart-internal-component-product-tile__quantity-selector button {
    background: transparent;
}
span.remove-text {
    color: rgba(53, 74, 84, 1);
    font-size: 12px;
    text-decoration: underline;
    letter-spacing: -1%;
    line-height: 18px;
    font-family: 'Avenir';
    font-weight: 400;
}
.styles_CustomButton__ a {
    font-size: 16px !important;
    font-weight: 800;
   font-family: 'Avenir';
    letter-spacing: 0%;
     position: relative;
}
img.lock_icon {
    position: absolute;
    right: 20px;
    top: 18px;
}
    .upcart-internal-component-upsell-tile__price {
    font-size: 15px;
    color: rgba(53, 74, 84, 1);
   font-family: 'Avenir';
    font-weight: 800;
}
    
    span.btn-content svg {
    margin: 0px !important;
}
    .upcart-internal-component-upsell-tile__title {
    color: rgba(0, 128, 191, 1);
}
    .upcart-internal-discount-code__form {
    border: 1px solid rgba(255, 255, 255, 1);
    background: rgba(255, 255, 255, 0.64);
    border-radius: 32px;
    height: auto;
    min-height: 52px;
}
    .upcart-internal-discount-code__form input {
    background-color: transparent;
}
    .upcart-internal-discount-code__input-wrapper {
    border: 0px;
    background: transparent;
}
    .upcart-internal-discount-code__form input {
    font-family: 'Avenir';
    font-weight: 400;
}
    .upcart-internal-discount-code__form button {
    font-size: 16px;
    font-family: 'Avenir';
    font-weight: 400;
}
    .UpcartDesignSettings__subtotalTextColor {
    color: rgba(53, 74, 84, 1);
    font-family: 'Avenir';
    font-size: 18px;
    font-weight: 600;
}
    .styles_Footer__checkoutButton__ {
    margin-bottom: 10px;
}
      .empty_cart_content {
    display: flex;
    flex-direction: column;
    align-items: baseline;
    row-gap: 26px;
      padding: 0px 30px;
}
    .styles_CartPreview__empty__ h3:empty {
    display: none;
}
    .styles_CartPreview__backdrop__ {
    background: #222F35;
}
    .empty_cart_content img {
    mix-blend-mode: darken;
}
    .styles_CartPreview__empty__ h3 {
    color: rgba(53, 74, 84, 1);
    font-size: 36px;
    font-weight: 900;
    line-height: 33px;
    text-align: left;
    font-family: 'Avenir';
    letter-spacing: -2%;
}
.empty_cart_content a {
    background: rgba(53, 74, 84, 1) !important;
    width: 100%;
    border-radius: 32px !important;
    font-size: 16px;
    letter-spacing: 0%;
     font-family: 'Avenir';
    font-weight: 800;
}
    .upcart-internal-component-product-tile__quantity-selector {
    display: flex;
    align-items: center;
    border: 1px solid #354a54;
    overflow: hidden;
    height: 28px;
    border-radius: 50px;
}
    .upcart-internal-component-upsell-tile__image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
    background: #fff;
    border-radius: 14px;
}
    .styles_CartPreview__card__:nth-child(3) {
    background: #000;
}
select.upsell-variant-option {
    width: 100%;
    border-radius: 50px;
    height: 27px;
    padding: 4px;
}


@media(min-width: 320px) and (max-width: 374px){
    .upcart-internal-component-upsell-tile {
    flex-direction: column;
    row-gap: 10px;
}
}


@media(max-width: 767px){
select.upsell-variant-option option {
    font-size: 10px !important;
}
    select.upsell-variant-option{
    font-size: 10px !important;
    height: 22px;
}
    .upcart-internal-component-upsell-tile {
    padding: 10px;
}
    .upcart-internal-component-upsell-tile__price {
    font-size: 12px;
}
.upcart-internal-component-segmented-progress-bar__milestone-label--align-center {
    left: -50%;
    transform: translate(0%, 32%);
}
        .upcart-internal-rewards.upcart-public-rewards {
    padding: 12px 24px 42px;
    min-height: auto;
    margin: 0px 14px;
}
    .upcart-internal-rewards__message.upcart-public-rewards__message p {
    font-size: 12px;
}
    .upcart-internal-component-segmented-progress-bar__segments-container {
    width: auto;
}
    .upcart-internal-component-product-tile.upcart-public-component-product-tile {
    margin: 0px 14px;
}
    .upcart-internal-component-segmented-progress-bar__milestone-label {
    font-size: 8px;
    line-height: 9px;
    padding-top: 0px;
    width: 50px;
}
}
   `;
 shadowRoot.appendChild(style);  

  }
    injectCSS();
})();






//script for table of content
document.addEventListener("DOMContentLoaded", function () {

  const tocWrapper = document.getElementById("table-of-contents");
  const tocList = document.getElementById("toc-list");

  if (!tocWrapper || !tocList) return;

  // Get page/blog content only
  const content =
    document.querySelector(".blog-post-content") ||
    document.querySelector(".shopify-block.rte") ||
    document.querySelector(".section-content-wrapper");

  if (!content) return;

  // Get all H2
  const headings = content.querySelectorAll("h2");

  // Clear old items
  tocList.innerHTML = "";

  if (!headings.length) {
    tocWrapper.style.display = "none";
    return;
  }

  headings.forEach((heading, index) => {

    const headingText = heading.textContent.trim();

    if (!headingText) return;

    // Add unique ID
    if (!heading.id) {
      heading.id = "toc-heading-" + index;
    }

    const li = document.createElement("li");

    const a = document.createElement("a");
    a.href = "#" + heading.id;
    a.textContent = headingText;

      a.addEventListener("click", function (e) {
      e.preventDefault();

      const headerOffset = 100; 
      const elementPosition = heading.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    });



    li.appendChild(a);
    tocList.appendChild(li);

  });

  // Show TOC only if items exist
  if (tocList.children.length) {
    tocWrapper.style.display = "block";
  }

});

//table of content script end




 document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll(".collection-desc-wrapper");

  wrappers.forEach((wrapper) => {
    const btn = wrapper.querySelector(".read-more-btn");
    const content = wrapper.querySelector(".collection-desc-content");

    if (btn && content) {
      btn.addEventListener("click", function () {
        content.classList.toggle("is-open");
        btn.classList.toggle("active");

        const text = btn.querySelector(".btn-text");

        if (content.classList.contains("is-open")) {
          text.textContent = "Read less";
        } else {
          text.textContent = "Read more";
        }
      });
    }
  });
});





document.addEventListener("DOMContentLoaded", function () {
  const blocks = document.querySelectorAll(".icon-block__wrapper");

  blocks.forEach((block) => {
    block.addEventListener("click", function () {
      // remove active from all
      blocks.forEach((b) => b.classList.remove("is-active"));

      // add active to clicked
      this.classList.add("is-active");
    });
  });
});





//color second letter on blog page

document.addEventListener("DOMContentLoaded", function () {

  const main = document.querySelector('main[data-template="article"]');

  if (!main) return;

  document.querySelectorAll(".hero__container .text-block h1").forEach(el => {

    let text = el.textContent.trim();

    if (text.length > 1) {
      el.innerHTML =
        text.charAt(0) +
        '<span class="second-letter">' +
        text.charAt(1) +
        '</span>' +
        text.slice(2);
    }

  });

});


//end





//cart timer issue
console.log("SCRIPT STARTED");

let resizeAttached = false;

function init(){

 const shadowRoot =
 document.querySelector(
   "#upCart"
 )?.shadowRoot;

 if(!shadowRoot){

   requestAnimationFrame(init);

   return;
 }

 const footer =
 shadowRoot.querySelector(
   ".upcart-footer"
 );

 const announcement =
 shadowRoot.querySelector(
   ".upcart-internal-announcement"
 );

 if(
   !footer ||
   !announcement
 ){

   requestAnimationFrame(init);

   return;
 }

 function updatePosition(){

   const height =
   footer.offsetHeight;

   announcement.style.bottom =
   `${height + 4}px`;

   console.log(
     "UPDATED:",
     height
   );

 }

 updatePosition();

 if(!resizeAttached){

   resizeAttached = true;

   const resizeObserver =
   new ResizeObserver(()=>{

     updatePosition();

   });

   resizeObserver.observe(
     footer
   );

 }

}

init();

//end here